import axios from "axios";
import apiUrl from "../Apiurl";

const USERNAME_MANCANTE =
  "Username Domino mancante: impossibile tracciare la traduzione. Verifica il profilo utente.";

// Username applicativo per l'audit delle traduzioni: prima quello del profilo
// Domino gia' caricato, altrimenti il profilo riletto via Auth0. Nessun
// ripiego su identita' diverse (sub Auth0, nomi tecnici).
export async function resolveTranslationUsername({ username, email, accessToken }) {
  const caricato = typeof username === "string" ? username.trim() : "";
  if (caricato) return caricato;
  if (email) {
    const profile = await axios.get(
      `${apiUrl}/auth/getUser/${encodeURIComponent(email)}`,
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );
    const riletto = typeof profile.data?.username === "string"
      ? profile.data.username.trim()
      : "";
    if (riletto) return riletto;
  }
  throw new Error(USERNAME_MANCANTE);
}

export function translationErrorMessage(error) {
  return error?.response?.data?.error || error?.message ||
    "Errore durante la traduzione del prodotto.";
}

// Errore parziale di /translate/blindly: alcune lingue sono state salvate e la
// risposta porta il prodotto aggiornato, da applicare per non restare su una
// copia superata (e non sovrascrivere le traduzioni al salvataggio).
export function translationErrorProduct(error) {
  const prodotto = error?.response?.data?.prodotto;
  return prodotto && typeof prodotto === "object" ? prodotto : null;
}
